<template>
  <div class="Cards">
    <div>
      <div class="input_item card">
        <div class="title">Card Number</div>
        <input placeholder="1234 1234 1234 1234" type="text" class="input" v-model="card" @input="onInput"
               @keyup="onInput" @paste="onInput">
      </div>
      <div class="data_cvv">
        <div class="input_item date">
          <div class="title">Expiry Date</div>
          <input type="tel" maxlength="2" class="input input_date" v-model="List.expiryMonth"
                 @blur="DateMMTime(List.expiryMonth)" placeholder="MM">
          <span class="solid">/</span>
          <input type="tel" maxlength="2" class="input input_date" v-model="List.expiryYear"
                 @blur="DateDDTime(List.expiryYear)" placeholder="YY">
        </div>
        <div class="input_item cvv">
          <div class="title">CVV</div>
          <input type="password" class="input input_cvv" maxlength="3" placeholder="***" v-model="List.cvv"
                 @keyup="List.cvv=List.cvv.replace(/\D/g,'')"
                 @onafterpaste="this.List.cvv=this.List.cvv.replace(/\D/g,'')">
        </div>

      </div>
      <div class="tip" v-if="flag">Please enter the correct date, such as 01/01</div>
      <!-- @click="getInfo()" -->
      <div class="pin input_item">
        <div class="title">PIN</div>
        <div class="pin_code">
          <input type="password" placeholder="·" v-model="pin1" maxlength="1" @keyup="cursorblur(pin1,1)" id="pin1">
          <input type="password" placeholder="·" v-model="pin2" maxlength="1" @keyup="cursorblur(pin2,2)" id="pin2">
          <input type="password" placeholder="·" v-model="pin3" maxlength="1" @keyup="cursorblur(pin3,3)" id="pin3">
          <input type="password" placeholder="·" v-model="pin4" maxlength="1" @keyup="cursorblur(pin4,4)" id="pin4">
        </div>
      </div>
      <div class="payment" @click="getInfo"> ₦ Pay {{ Params.amount || 0 }}<img src="../../../assets/images/submit.png"/>
      </div>
    </div>

    <van-overlay :show="overlayStatus">
      <van-loading color="#1989fa" size="60px"/>
    </van-overlay>
    <van-dialog v-model="Verification_code" title="Please enter the verification code" confirmButtonText="Confirm"
                cancelButtonText="Cancel" :before-close="beforeClose" show-cancel-button>
      <input type="text" class="Verification_code" placeholder="Verification code" id="Verification_code"
             v-model="code">
    </van-dialog>
    <!-- <div class="loading">
        <van-loading color="#1989fa" size="60px" v-show="loading" />
    </div>  -->
  </div>
</template>
<script>

export default {
  data() {
    return {
      card: '',
      time: '',
      MM: '',
      DD: '',
      flag: false,
      status: false,
      overlayStatus: false,
      pin1: '',
      pin2: '',
      pin3: '',
      pin4: '',
      code: '',
      Verification_code: false,
      orderId: '',
      request_flag: true,
      loading: false,
      List: {
        cardNumber: "",
        cardName: "",
        cvv: "",
        expiryMonth: "",
        expiryYear: "",
        pin: ""
      },
      CardList: {}
    }
  },
  props: ['Params', "UserInfo"],
  mounted() {
    this.List['sign'] = localStorage.getItem('sign')
    // 在这里直接赋值 是拿不到props的 （改用watch）
    // this.List = {...this.List, ...this.Params, ...this.UserInfo}
  },
  watch: {
    Params(val) {
      this.List = {...this.List, ...val}
      // this.List.amount = parseInt(val.amount || '0').toFixed(2)
    },
    UserInfo(val) {
      this.List = {...this.List, ...val}
    }
  },
  methods: {
    firstCopySuccess(e) {
      this.$toast("Account copied successfully!")
    },
    firstCopyError(e) {
      console.log(e)
      this.$toast("Fail!")
    },
    //操作银行卡
    onInput: function (event) {
      this.card = this.card.replace(/\D/g, '') // 不允许输入非数字字符
      this.card = this.card.replace(/(\d{4})(?=\d)/g, '$1 ') // 4位
    },
    //操作时间
    onInputTime: function (event) {
      this.time = this.time.replace(/[^\d/]/g, '') // 不允许输入非数字字符
      if (window.event.keyCode == 46) {
        alert("11111")
      }
    },
    // 时间判断
    DateMMTime(value) {
      if (value < 10 && Number(value) > 0 && value.length < 2) {
        this.List.expiryMonth = '0' + value
        this.flag = false
      } else if (value > 12 || Number(value) == 0) {
        this.flag = true
      } else {
        this.flag = false
      }
    },
    DateDDTime(value) {
      if (value < 10 && Number(value) > 0 && value.length < 2) {
        this.List.expiryYear = '0' + value
        this.flag = false
      } else if (Number(value) == 0) {
        this.flag = true
      } else {
        this.flag = false
      }
    },
    getInfo() {
      if (this.pin1 == '' || this.pin2 == '' || this.pin3 == '' || this.pin4 == '') {
        this.$toast('The pin cannot be empty')
        return
      }
      this.overlayStatus = true
      this.List.paymentType = 1
      this.List.cardNumber = this.card.replace(/\s*/g, "")
      this.List.pin = this.pin1 + this.pin2 + this.pin3 + this.pin4
      this.List['timestamp'] = new Date().getTime()
      console.log(this.List)
      this.axios.post('/api/order/submit', {...this.List}).then(res => {
        if (res.data.code == 0) {
          this.overlayStatus = false
          this.status = true
          if (res.data.data.cardAuthType == 0) {
            // this.Verification_code = true
            // setTimeout(()=>{document.getElementById("Verification_code").focus()},200)
            // this.orderId = res.data.data.orderId
            // this.sendSMS(res.data.data.orderId)
            this.payment()
          } else if (res.data.data.cardAuthType == 1) {
            this.orderId = res.data.data.orderId
            this.sendSMS(res.data.data.orderId)

          } else if (res.data.data.cardAuthType == 2) {
            window.location.href = res.data.data.cardAuthUrl
          }

        } else {
          this.$toast(res.data.error)
          this.overlayStatus = false
        }
      })

    },
    sendSMS(orderId) {
      this.axios.post('/api/order/naps/payment/otpresend', {
        merchantId: Number(this.Params.merchantId),
        channelOrderId: orderId
      }).then(res => {
        if (res.data.code == 0) {
          this.Verification_code = true
        } else {
          this.$toast(res.data.error)
        }

      })
    },
    beforeClose(action, done) {
      if (action == 'confirm') {
        if (this.code == '') {
          this.$toast('Please enter the verification code')
          done(false)
          return
        }
        this.axios.post('/api/order/naps/payment/otpauth', {
          merchantId: Number(this.Params.merchantId),
          channelOrderId: this.orderId,
          otp: this.code
        }).then(res => {
          if (res.data.code == 0) {
            done(true)
            this.code = ''
            this.payment()
          } else {
            done(false)
            this.$toast(res.data.error)
          }
        })
      } else {
        done(true)
        this.code = ''
      }

    },
    payment() {
      if (!this.request_flag) {
        return
      }
      this.request_flag = false
      this.axios.post('/api/order/paymentStatus', {
        requestParam: encryption({
          merchantId: this.List.merchantId,
          merchantOrderId: this.List.merchantOrderId
        })
      }).then(res => {
        if (res.data.data.status == 0) {
          // 待支付
          this.$toast('Your money will be comfirmed in few minutes')
        } else if (res.data.data.status == 1) {
          // this.$toast('Congratulations,your payment successful')
          this.$router.push({path: '/success', query: {'image': this.UserInfo.logoUrl}})
        } else if (res.data.data.status == 2) {
          // this.$toast('Failure to pay')
          this.$router.push({path: '/timeout', query: {'image': this.UserInfo.logoUrl}})

        }
        this.request_flag = true
      })
    },
    cursorblur(value, id) {
      let num = id + 1
      if (value != '' && id != 4) {
        let coder = document.getElementById("pin" + num)
        coder.focus()
      }
    }
  }
}
</script>

<style scoped lang="scss">

.Cards {
  margin: 0.4rem 0;

  .van-loading {
    margin-top: 50%;
  }

  .remarks {
    font-size: 0.32rem;
    padding: 0.1rem 0 0.1rem;
    color: #1F026B;
    font-weight: bold;
  }

  .tip {
    text-align: left;
    font-size: 0.24rem;
    color: red;
    line-height: 0.6rem;
    padding-left: 0.1rem;
  }

  .payment {
    background: #283B51;
    border-radius: 0.1rem;
    height: 0.9rem;
    line-height: 0.9rem;
    color: #fff;
    font-weight: 200;
    font-size: 0.3rem;
    margin-top: 0.4rem;

    img {
      vertical-align: middle;
      margin-left: 0.2rem;
    }
  }
}

.input_item {
  margin-top: 0.2rem;
  text-align: left;
  background-color: #FFFFFF;
  padding: 0.2rem 0.2rem;

  .title {
    color: #283B51;
    font-weight: 600;
    font-size: 0.28rem;
    text-align: left;
    line-height: 0.6rem;
    margin-bottom: 0.08rem;
  }

  .input {
    border: 1px solid #eee;
    display: block;
    height: 0.8rem;
    width: 100%;
    border-radius: 0.1rem;
    box-sizing: border-box;
    padding: 0 0.2rem;
    font-weight: bold;
    font-size: 0.28rem;
  }

  .input_date {
    width: 40%;
    display: inline-block;
  }

  .input_cvv {
    height: 0.8rem;
    display: inline-block;
  }

  input::-webkit-input-placeholder {
    color: #d7d7d7;

  }

  input:focus {
    border: 1px solid #1F026B;
  }

  .pin_code {
    display: flex;
    justify-content: space-between;

    input {
      width: 20%;
      text-align: center;
      border: 1px solid #eee;
      height: 0.8rem;
      border-radius: 0.1rem;
      box-sizing: border-box;
      font-weight: bold;
      font-size: 0.28rem;

    }

    input:focus {
      border: 1px solid #1F026B;
    }
  }
}

.data_cvv {
  display: flex;
  justify-content: space-between;
}

.date {
  width: 60%;

  .solid {
    color: #000000;
    font-size: 0.3rem;
    padding: 0 0.1rem;
  }
}

.Verification_code {
  margin: 0.4rem 0;
  border: 1px solid #eee;
  height: 0.9rem;
  border-radius: 0.1rem;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 0.28rem;
  text-align: center;
}

input::-webkit-input-placeholder {
  color: #d7d7d7;
}

input:focus {
  border: 1px solid #1F026B;
}

.loading {
  position: absolute;
  top: 30%;
  left: 50%;
  margin-left: -30px;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/pages/ngn/components/card.vue